import { useTranslate } from "@refinedev/core";

/**
 * Select options for the Key points (backend `Summary`) add-on config card.
 */
export const useKeyPointsConfigData = () => {
  const t = useTranslate();

  // Option values are the API units (`SummaryLength`/`SummaryFormat`/
  // `ReadingLevel` enums) so the stored form value needs no translation.
  const lengthOptions = [
    { value: "Short", label: t("createExperience.addOns.keyPoints.length.short") },
    { value: "Medium", label: t("createExperience.addOns.keyPoints.length.medium") },
    { value: "Long", label: t("createExperience.addOns.keyPoints.length.long") },
  ];

  const formatOptions = [
    { value: "BulletPoints", label: t("createExperience.addOns.keyPoints.format.bulletPoints") },
    { value: "Paragraphs", label: t("createExperience.addOns.keyPoints.format.paragraphs") },
  ];

  const readingLevelOptions = [
    { value: "Simple", label: t("createExperience.addOns.keyPoints.readingLevel.simple") },
    { value: "Standard", label: t("createExperience.addOns.keyPoints.readingLevel.standard") },
    { value: "Expert", label: t("createExperience.addOns.keyPoints.readingLevel.expert") },
  ];

  return {
    lengthOptions,
    formatOptions,
    readingLevelOptions,
  };
};
